/* 弹框-组件 */
export default{
	props:['openPopup'],
	methods:{
		closePopup(){
			this.$emit("update:openPopup", false);
		}
	}
}